<div class="dashboard-wrapper flex flex-column gap-5 pb-5">
  <p-dialog *ngIf="isNewUser" [(visible)]="welcomeDialogVisible" [modal]="true" [style]="{ width: '450px' }"
    [draggable]="false" [resizable]="false">
    <ng-template pTemplate="header">
      <div class="flex align-items-center justify-content-center">
        <h3 class="text-xl font-medium m-0">Welcome to GradPilots!</h3>
      </div>
    </ng-template>
    <div class="flex flex-column align-items-center gap-4">
      <img src="../../../assets/images/logo.svg" alt="GradPilot Logo" class="w-16 h-16" />
      <p class="text-center text-lg line-height-3 font-normal"
        style="font-family: 'Circular Std', sans-serif; line-height: 1.2;">
        Let's take a quick tour to help you get started with your High-Ed journey. We'll show you the key features
        and how to make the most of your dashboard.
      </p>
    </div>
    <ng-template pTemplate="footer">
      <div class="flex justify-content-center gap-2">
        <p-button label="Skip Tour" (click)="skipTour()" styleClass="p-button-text"></p-button>
        <p-button label="Start Tour" (onClick)="startTour()" styleClass="p-button-primary"></p-button>
      </div>
    </ng-template>
  </p-dialog>

  <!-- Skeleton while progress data loads — prevents first-login/returning view flash -->
  <app-dashboard-skeleton *ngIf="isDashboardLoading"></app-dashboard-skeleton>

  <!-- Real dashboard: rendered directly in the correct state once progress is known -->
  <ng-container *ngIf="!isDashboardLoading">
    <!-- Main Grid: Left Column (Welcome Banner + Quick Actions) & Right Column (Profile Completion) -->
    <div class="top-row">
      <div class="left-column flex flex-column justify-content-between" style="flex: 2; min-width: 0; height: 100%;">
        <app-dashboard-welcome-banner style="display: block; flex: 1; margin-bottom: 24px;"
          [firstName]="user?.firstName || 'Student'" [isFirstTime]="isNewUser"></app-dashboard-welcome-banner>
        <app-dashboard-quick-actions style="display: block;"></app-dashboard-quick-actions>
      </div>
      <div class="right-column" style="flex: 1; min-width: 0;">
        <app-dashboard-profile-completion [firstName]="user?.firstName || 'Student'"
          [completionPercentage]="profileStatusInfo?.finalWeightage || 0" [completionItems]="profileCompletionItems">
        </app-dashboard-profile-completion>
      </div>
    </div>

    <app-dashboard-milestones *ngIf="isReturningStudent" [overallProgress]="progressInfo?.finalWeightage || 0"
      [profileCompletedCount]="progressStats?.profileCompletionPercentage || 0"
      [collegesSaved]="progressStats?.collegeSavedCount || 0" [memberSince]="progressStats?.memberSince || null"
      [documentsUploaded]="progressStats?.uploadedDocumentsCount || 0"
      [savedScholarships]="progressStats?.savedScholarshipCount || 0" [journeyEvents]="journeyEvents"
      [consistencyStreak]="loginStreak?.currentStreak || 0" [streakActiveToday]="loginStreak?.isActiveToday || false"
      [upcomingTasks]="pendingCheckListTasks?.additionalInfo || []">
    </app-dashboard-milestones>

    <app-dashboard-applications *ngIf="isReturningStudent" [studentId]="user?.id || ''"
      (applicationsLoaded)="applicationCount = $event"></app-dashboard-applications>

    <app-dashboard-promo-sections></app-dashboard-promo-sections>
  </ng-container>
</div>

<app-dashboard-testimonials *ngIf="!isDashboardLoading && !isReturningStudent"></app-dashboard-testimonials>


<!-- Keep existing task dialogs invisible until triggered -->
<p-dialog header="Task" [modal]="true" [(visible)]="visible" [style]="{ width: '30rem' }">
  <form class="flex flex-column align-items-center gap-3 w-full" [formGroup]="additionalInformationForm"
    (ngSubmit)="onReplySubmit()">
    <div class="popup-container">
      <div class="w-full flex flex-column gap-3 ">
        <textarea formControlName="additionalInfo" placeholder="Enter Task..." style="min-height: 96px;"
          class="w-full p-2 font-normal text-base" rows="5" cols="45" pInputTextarea>
        </textarea>
        <small class="text-red-500 block" *ngIf="additionalInformationForm.get('additionalInfo')?.invalid &&
              (submitted || additionalInformationForm.get('additionalInfo')?.touched)">
          Task Reply is required
        </small>
        <div class="w-full flex align-items-center gap-2">
          <p-fileUpload styleClass="fileupload" #fileUploader mode="basic" name="demo[]" chooseIcon="pi pi-upload"
            url="https://www.primefaces.org/cdn/api/upload.php" accept=".pdf,.doc,.docx,image/*" maxFileSize="1000000"
            fileLimit="1" (onSelect)="onFileSelect($event)" [auto]="false" chooseLabel="Browse" />
          <p-button class="font-regular" (onClick)="onFileRemoved()" icon="pi pi-times" styleClass="closeIcon"
            [rounded]="true" appendTo="body" pTooltip="Clear image" tooltipPosition="top" />
        </div>
        <div class="flex align-items-center justify-content-center">
          <p-button label="Submit" styleClass="popTaskSave" type="submit" />
        </div>
      </div>
    </div>
  </form>
</p-dialog>